import { render, staticRenderFns } from "./milestone-detail.view.vue?vue&type=template&id=3b24db36&scoped=true&"
import script from "./milestone-detail.view.vue?vue&type=script&lang=ts&"
export * from "./milestone-detail.view.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-detail.view.vue?vue&type=style&index=0&id=3b24db36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24db36",
  null
  
)

export default component.exports